import Service from "@/api/attendance/statusOdontogramaServices";

export default {
  loadTable({ commit }, pageConfig) {
    return new Promise((resolve, reject) =>
      Service.loadTable(pageConfig)
        .then((result) => {
          commit("LOAD_LIST", result.data.content);
          resolve(result);
        })
        .catch((err) => reject(err))
    );
  },
  insertNew({ commit }, data) {
    return Service.insertNew(data)
      .then((result) => result)
      .catch((error) => error);
  },
  prepareToEdit({ commit }, data) {
    commit("PREPARE_TO_EDIT", data);
  },
  edit({ commit }, data) {
    return Service.edit(data)
      .then((result) => result)
      .catch((error) => error);
  },
  reset({ commit }) {
    commit("RESET");
  },
  delete({ commit }, id) {
    return Service.delete(id)
      .then((result) => result)
      .catch((error) => error);
  },
};
